import gui			from "gui";
import Dialog		from "dialog";
import template		from "../html/dialog-filebrowser.html";
import css			from "../css/dialog-filebrowser.css";
import DataTable	from "datatable";

class FilebrowserDialog extends Dialog {
	static get template() {
			return template;
	}
	static get css() {
			return css;
	}
	static constructor() {
		customElements.define("fulljs-dialog-filebrowser", FilebrowserDialog);
	}
	static get schema() {
		return({
			"type": "object",
			"description": "Label Control displays text.",
			"properties": {
				"text": {
					"type": "string",
					"description": "Text content of the Label Control",
					"default": "Label #n"
				}
			}
		});
	}
	static get designer() {
		return({
			"category": "Basic",
			"icon": {"context": "actions", "size": 16, "iconname": "insert-text"}
		});
	}
	constructor() {
		super();

	}
   list_dir(dir) {
		server.rcall("RM_fileserver_listdir", dir)
		.then(function(dirlist) {
				dirlist = dirlist.sort(function(a,b) {
						/* directories first */
						a = (a.st_type == 2 ? "d_" : "f_") + a.st_name;
						b = (b.st_type == 2 ? "d_" : "f_") + b.st_name;
						/* sort this: d_directory, f_filename.ext */
						return(a==b ? 0 : (a>b ? 1 : -1));
				});

				dirlist.forEach(function(item) {
						if (item.st_name=="index.html") return;
						if (item.st_name=="..") return;
						var row = this.datatableFilelist.appendChild( new DataTable.Row() );
						row.appendChild( new DataTable.Cell({"style": "width: 16px;"}) );
						row.appendChild( new DataTable.Cell({"value": item.st_name}) );
						row.appendChild( new DataTable.Cell({"value": item.st_size, "type": "number"}) );
						row.appendChild( new DataTable.Cell({"value": item.st_mtime, "type": "date"}) );
				}, this);

		}.bind(this))
		.catch(function(message) {
				alert(message);
		}.bind(this));
	}
	get url() {
		return this.textboxURL.value;
	}
	set url(URL) {
		this.textboxURL.value = URL;
	}
	datatableFilelist_click(event) {
		this.url = this.datatableFilelist.cell(this.datatableFilelist.selectedIndex, 1).value;
	}
	datatableFilelist_dblclick(event) {
		this.buttonOk_click();
	}
	buttonOk_click() {
		// create and dispatch the event
		var event = new CustomEvent("change", {
			detail: {
				url: this.url
			}
		});
		this.dispatchEvent(event);
		
		if (typeof this.onchange=="function") {
			this.onchange(event);
		}
		
	}
	buttonCancel_click() {
		this.close();
	}
	show() {
		super.show();
		this.list_dir();
	}
}

FilebrowserDialog.constructor();

export default FilebrowserDialog;